import { useState } from "react"
import InterviewAuthGuard from "../components/InterviewAuthGuard"

const INTERVIEWER_URL =
  "https://resolut.co.in/meeting/meeting_moohmew6?host=864611ec-fadb-451a-abd8-4c58aa968cfe"
const CANDIDATE_URL = "https://resolut.co.in/meeting/meeting_moohmew6"

// ── Role Select ───────────────────────────────────────────────────────────────
const RoleSelect = ({ name }) => {
  const [launched, setLaunched] = useState(null)

  const open = (url, role) => {
    window.open(url, "_blank", "noopener,noreferrer")
    setLaunched(role)
    setTimeout(() => setLaunched(null), 2500)
  }

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-zinc-50"
      style={{ fontFamily: "'Satoshi', sans-serif", padding: "20px" }}
    >
      <style>{`@import url('https://api.fontshare.com/v2/css?f[]=satoshi@400,500,600,700&display=swap');`}</style>

      <div
        className="bg-white border border-zinc-200 w-full"
        style={{ maxWidth: 440, borderRadius: 0 }}
      >
        {/* Header */}
        <div className="px-7 py-5 border-b border-zinc-100 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div
              className="w-7 h-7 flex items-center justify-center bg-zinc-100 border border-zinc-200 shrink-0"
              style={{ borderRadius: 0 }}
            >
              <svg width="14" height="14" viewBox="0 0 52 52" fill="none">
                <path
                  d="M26 4L46 16V36L26 48L6 36V16L26 4Z"
                  stroke="#18181b"
                  strokeWidth="3"
                  fill="none"
                />
                <path
                  d="M26 4L26 48M6 16L46 36M46 16L6 36"
                  stroke="#18181b"
                  strokeWidth="1.5"
                  opacity="0.35"
                />
              </svg>
            </div>
            <p className="text-[11px] font-bold uppercase tracking-widest text-zinc-900">
              AI Copilot Demo
            </p>
          </div>
          <span
            className="text-[10px] font-bold uppercase tracking-widest px-2 py-0.5 bg-emerald-50 border border-emerald-200 text-emerald-600"
            style={{ borderRadius: 0 }}
          >
            Verified
          </span>
        </div>

        {/* Body */}
        <div className="px-7 py-6">
          <div className="mb-6">
            <h2 className="text-xl font-bold text-zinc-900 leading-snug mb-1">
              Welcome, {name}
            </h2>
            <p className="text-[14px] text-zinc-500 leading-relaxed">
              Choose how you'd like to join the live demo session.
            </p>
          </div>

          {/* Interviewer button */}
          <button
            onClick={() => open(INTERVIEWER_URL, "interviewer")}
            className="w-full text-left border border-zinc-200 hover:border-zinc-900 transition-all duration-150 mb-3 group"
            style={{ borderRadius: 0, background: "none", padding: 0 }}
          >
            <div className="px-5 py-4">
              <div className="flex items-center justify-between mb-1.5">
                <p className="text-[13px] font-bold text-zinc-900 uppercase tracking-widest">
                  Join as Interviewer
                </p>
                <span className="text-[11px] font-bold text-zinc-400 group-hover:text-zinc-900 transition-colors">
                  →
                </span>
              </div>
              <p className="text-[13px] text-zinc-500 leading-relaxed">
                Access the AI Copilot with real-time suggestions, inbuilt code editor, notes and much more
              </p>
            </div>
          </button>

          {/* Candidate button */}
          <button
            onClick={() => open(CANDIDATE_URL, "candidate")}
            className="w-full text-left border border-zinc-200 hover:border-zinc-900 transition-all duration-150 group"
            style={{ borderRadius: 0, background: "none", padding: 0 }}
          >
            <div className="px-5 py-4">
              <div className="flex items-center justify-between mb-1.5">
                <p className="text-[13px] font-bold text-zinc-900 uppercase tracking-widest">
                  Join as Candidate
                </p>
                <span className="text-[11px] font-bold text-zinc-400 group-hover:text-zinc-900 transition-colors">
                  →
                </span>
              </div>
              <p className="text-[13px] text-zinc-500 leading-relaxed">
                Experience the platform from the candidate's perspective
              </p>
            </div>
          </button>

          {/* Launch toast */}
          {launched && (
            <div
              className="mt-4 flex items-center gap-2.5 px-4 py-3 border border-zinc-200 bg-zinc-50"
              style={{ borderRadius: 0 }}
            >
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" />
              <p className="text-[12px] font-bold text-zinc-600 uppercase tracking-widest">
                Opening {launched} session in new tab…
              </p>
            </div>
          )}

          <p className="text-[11px] text-zinc-400 text-center mt-5 font-medium">
            Both roles connect to the same live demo session.
          </p>
        </div>
      </div>
    </div>
  )
}

// ── Page ──────────────────────────────────────────────────────────────────────
const AiCopilotDemoPage = () => {
  const [verifiedName, setVerifiedName] = useState(null)

  return (
    <InterviewAuthGuard
      roleName="AI Copilot Demo"
      onVerified={(name) => setVerifiedName(name)}
    >
      {verifiedName && <RoleSelect name={verifiedName} />}
    </InterviewAuthGuard>
  )
}

export default AiCopilotDemoPage
